import { CanHistoryMessages, TranslationCanHistoryMessages } from "../interfaces/canHistoryMessages";

const canHistoryMessages: TranslationCanHistoryMessages = {
  [CanHistoryMessages.title]: "Histórico CAN",
  [CanHistoryMessages.dateTime]: "Data/Hora",
  [CanHistoryMessages.fleet]: "Frota",
  [CanHistoryMessages.plate]: "Placa",
  [CanHistoryMessages.travelDoc]: "NF",
  [CanHistoryMessages.status]: "Status",
  [CanHistoryMessages.driver]: "Motorista",
  [CanHistoryMessages.ignition]: "Ignição",
  [CanHistoryMessages.ignitionOn]: "Ligada",
  [CanHistoryMessages.ignitionOff]: "Desligada",
  [CanHistoryMessages.odometer]: "Odômetro",
  [CanHistoryMessages.totalFuel]: "Combustível Total",
  [CanHistoryMessages.speed]: "Velocidade",
  [CanHistoryMessages.rpm]: "RPM",
  [CanHistoryMessages.coolantTemp]: "Temp. Arrefecimento",
  [CanHistoryMessages.fuelConsumption]: "Consumo Combustível",
  [CanHistoryMessages.fuelLevel]: "Nível Combustível",
  [CanHistoryMessages.hourmeter]: "Horímetro",
  [CanHistoryMessages.totalDrivingTime]: "Tempo Total Direção",
  [CanHistoryMessages.idleFuel]: "Combustível Ocioso",
  [CanHistoryMessages.address]: "Endereço",
  [CanHistoryMessages.rawDataTooltip]: "Dado bruto do rastreador (sem normalização CAN)"
};

export const messages = canHistoryMessages;
